<template>
    <article class="bg-gray-50 rounded-lg shadow-sm overflow-hidden" :aria-labelledby="headlineId">
        <header
            class="border-b"
            :class="{
                'bg-koelnmesse/10 border-b-koelnmesse/10': props.variant === 'Koelnmesse',
                'bg-yellow-100 border-b-yellow-800/10': props.variant === 'Yellow',
                'bg-gray-100 border-b-gray-800/10': props.variant === 'Gray',
            }"
        >
            <slot name="header" v-bind="{ headlineId }" />
        </header>

        <slot />

        <footer v-if="$slots['footer']" class="bg-red-700 text-red-50">
            <slot name="footer" />
        </footer>
    </article>
</template>

<script setup lang="ts">
import { useId } from 'vue';

export type AccentCardVariant = 'Koelnmesse' | 'Yellow' | 'Gray';

type AccentCardProps = {
    variant: AccentCardVariant;
};

const props = defineProps<AccentCardProps>();

const headlineId = useId();
</script>
